import { apiClient } from "lib/axios";

export const getAccounts = async (params = {}) => {
  const { data } = await apiClient.get("/accounts", { params });
  return data;
};

export const getTrialBalance = async (params = {}) => {
  const { data } = await apiClient.get("/accounting/reports/trial-balance", {
    params,
  });
  return data;
};

export const getGeneralLedger = async (params = {}) => {
  const { data } = await apiClient.get("/accounting/reports/general-ledger", {
    params,
  });
  return data;
};

export const getAccountsReceivableAging = async (params = {}) => {
  const { data } = await apiClient.get("/accounting/reports/ar-aging", {
    params,
  });
  return data;
};

export const getProfitAndLoss = async (params = {}) => {
  const { data } = await apiClient.get("/accounting/reports/profit-loss", {
    params,
  });
  return data;
};

export const getBalanceSheet = async (params = {}) => {
  const { data } = await apiClient.get("/accounting/reports/balance-sheet", {
    params,
  });
  return data;
};

export const refreshOverdueInvoices = async (body = {}) => {
  const { data } = await apiClient.post(
    "/accounting/receivables/refresh-overdue",
    body,
  );
  return data;
};

export const getJournalEntries = async (params = {}) => {
  const { data } = await apiClient.get("/accounting/journal-entries", {
    params,
  });
  return data;
};

export const getJournalEntryById = async (id) => {
  const { data } = await apiClient.get(`/accounting/journal-entries/${id}`);
  return data;
};
